<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：支付宝业务员列表
  -->
  <div class="product-list">
    <!--搜索表单-->
    <!-- <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        
        <el-form-item label="商品名称"
          ><el-input
            size="small"
            v-model="searchForm.product_name"
            placeholder="请输入商品名称"
          ></el-input
        ></el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div> -->
    <!--添加产品-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加业务员</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="sales_id" label="id"></el-table-column>
          <el-table-column prop="user_id" label="业务员用户id"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="complete" label="成交金额"></el-table-column>
          <el-table-column label="佣金类型">
            <template slot-scope="scope">
              <span>{{ scope.row.commission_type == 1 ? '固定值' : '比例抽成' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="commission" label="单笔佣金"></el-table-column>

          <!-- <el-table-column label="url">
            <template slot-scope="scope">
              https://shoujizulin2.rchz.top/index2.html?id={{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label="二维码">
            <template slot-scope="scope">
              <el-button
                @click="getProQrcode(scope.row)"
                type="primary"
                size="small"
                >获取二维码222</el-button
              >
            </template>
          </el-table-column> -->
          <el-table-column prop="beizhu" label="备注"></el-table-column>
          <el-table-column prop="create_time" label="发布时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑业务员</el-button>
                <el-button @click="delClick(scope.row)" type="text" size="small">删除业务员</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- dialog -->
    <div>
      <!-- 添加业务员 -->
      <el-dialog title="添加业务员" :visible.sync="showAdddialog" class="dialogBox">
        <el-form :model="addUserData" label-width="100px">
          <el-form-item label="业务员名称">
            <el-input v-model="addUserData.name" placeholder="请填写业务员名称"></el-input>
          </el-form-item>
          <el-form-item label="业务员手机号">
            <el-input v-model="addUserData.mobile" placeholder="请填写业务员手机号"></el-input>
          </el-form-item>
          <el-form-item label="绑定业务员" :rules="[{ required: true, message: '请绑定业务员!' }]">
            <el-row>
              <el-button icon="el-icon-picture-outline" @click="userClick1()">选择用户</el-button>
              <div v-if="addUserData.user_id !== 0" class="img">
                <!-- <img :src="user_info.avatarUrl" width="100" height="100" /> -->
                业务员id：{{ addUserData.user_id }}
              </div>
            </el-row>
          </el-form-item>
          <!-- <el-form-item label="佣金类型">
            <el-radio-group v-model="addUserData.commission_type">
              <el-radio label="1">固定值</el-radio>
              <el-radio label="2">比例抽成</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="单笔佣金">
            <el-input v-model="addUserData.commission" placeholder="请填写单笔佣金"></el-input>
          </el-form-item> -->
          <el-form-item label="固定值">
            <el-input v-model="addUserData.commission" placeholder="请填写固定值"></el-input>
          </el-form-item>
          <el-form-item label="比例抽成">
            <el-input v-model="addUserData.commission_rate" placeholder="请填写比例抽成"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="addUserData.beizhu" placeholder="请填写备注"></el-input>
          </el-form-item>
          <!-- <el-form-item label="推广链接">
            <el-input v-model="addUserData.url" placeholder="请填写推广链接"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showAdddialog = false">取 消</el-button>
          <el-button type="primary" @click="submitAddUser">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑业务员 -->
      <el-dialog title="编辑业务员" :visible.sync="showEditdialog" class="dialogBox">
        <el-form :model="editUserData" label-width="100px">
          <el-form-item label="业务员名称">
            <el-input v-model="editUserData.name" placeholder="请填写业务员名称"></el-input>
          </el-form-item>
          <el-form-item label="业务员手机号">
            <el-input v-model="editUserData.mobile" placeholder="请填写业务员手机号"></el-input>
          </el-form-item>
          <el-form-item label="绑定业务员" :rules="[{ required: true, message: '请绑定业务员!' }]">
            <el-row>
              <el-button icon="el-icon-picture-outline" @click="userClick()">选择用户</el-button>
              <div v-if="editUserData.user_id !== 0" class="img">
                <!-- <img :src="user_info.avatarUrl" width="100" height="100" /> -->
                业务员id：{{ editUserData.user_id }}
              </div>
            </el-row>
          </el-form-item>
          <!-- <el-form-item label="佣金类型">
            <el-radio-group v-model="editUserData.commission_type">
              <el-radio :label="1">固定值</el-radio>
              <el-radio :label="2">比例抽成</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="单笔佣金">
            <el-input v-model="editUserData.commission" placeholder="请填写单笔佣金"></el-input>
          </el-form-item> -->
          <el-form-item label="固定值">
            <el-input v-model="editUserData.commission" placeholder="请填写固定值"></el-input>
          </el-form-item>
          <el-form-item label="比例抽成">
            <el-input v-model="editUserData.commission_rate" placeholder="请填写比例抽成"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="editUserData.beizhu" placeholder="请填写备注"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEditdialog = false">取 消</el-button>
          <el-button type="primary" @click="submitEditUser">确 定</el-button>
        </span>
      </el-dialog>
      <!-- e二维码 -->
      <el-dialog title="二维码" :visible.sync="QrcodeDialog" width="30%">
        <div style="display:flex;justify-content: center;align-items: center;">
          <img :src="'https://' + qrcode">
        </div>
      </el-dialog>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
        layout="total, prev, pager, next, jumper,sizes" :total="totalDataNumber"></el-pagination>
    </div>
    <GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>
    <GetUser :is_open="open_user2" @close="closeDialogFunc1($event, 'add')"></GetUser>
  </div>

</template>

<script>
import PromotionApi from "@/api/promotion.js";
import GetUser from './GetUser.vue';

export default {
  components: {
    /*选择用户*/
    GetUser
  },
  data() {
    return {
      open_user: false,
      open_user2: false,
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: "",
        category_id: "",
      },
      /*列表数据*/
      tableData: [],
      //   控制添加业务员展示
      showAdddialog: false,
      addUserData: {
        // display_Port: 1
        name: '',
        mobile: '',
        user_id: 0,
        commission_type: '',
        commission: '',
        commission_rate:'',
        beizhu: '',
      },
      //   编辑业务员展示
      showEditdialog: false,
      editUserData: {
        sales_id:'',
        name: '',
        mobile: '',
        user_id: 0,
        commission_type: '',
        commission: '',
        commission_rate:'',
        beizhu: '',
      },
      //  二维码弹窗
      QrcodeDialog: false,
      qrcode: "",
    };
  },
  created() {
    /*获取列表*/
    this.getData();
    this.getValue()

  },
  methods: {
    /*关闭获取用户弹窗*/
    closeDialogFunc1(e) {
      console.log(e);
      if (e.type != 'error') {
        this.user_info = e.params;
        this.addUserData.user_id = e.params.user_id;
        // this.form.supplier.user_id = e.params[0].user_id;
      }
      this.open_user2 = false;
    },
    /*打开弹出层*/
    userClick1() {
      this.open_user2 = true;
    },
    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      console.log(e);
      if (e.type != 'error') {
        this.user_info = e.params;
        this.addUserData.user_id = e.params.user_id;
        // this.form.supplier.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },
    /*打开弹出层*/
    userClick() {
      this.open_user = true;
    },
    /*打开添加*/
    addClick() {
      this.showAdddialog = true;
    },
    // 提交添加业务员
    submitAddUser() {
      let self = this;
      let Params = self.addUserData;
      if (Params.name == '') {
        self.$message({
          message: "请输入真实姓名！",
          type: "warning"
        });
        return false;
      }
      if (Params.mobile == '') {
        self.$message({
          message: "请输入手机号码！",
          type: "warning"
        });
        return false;
      }
      let reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      if (!reg.test(Params.mobile)) {
        self.$message({
          message: "手机号码格式不正确！",
          type: "warning"
        });
        return false;
      }
      if (Params.user_id == 0) {
        self.$message({
          message: "请绑定推广人！",
          type: "warning"
        });
        return false;
      }
      PromotionApi.addSales(Params, true)
        .then((data) => {
          self.$message({
            message: "添加成功",
            type: "success",
          });
          self.addUserData.beizhu = '';
          self.addUserData.name = '';
          self.addUserData.mobile = '';
          self.addUserData.user_id = 0;
          self.getData();
        })
        .catch((err) => {
          console.log(err, "=--err");
        });

      self.showAdddialog = false;
    },
    // 获取二维码
    getProQrcode(row) {
      let url = "https://shoujiuzlin2.rchz.top/index2.html?id=" + row.id;
      PromotionApi.getQrcodeUel(
        {
          url: url,
        },
        true
      )
        .then((data) => {
          this.qrcode = data.data.qrcode;
        })
        .catch((err) => {
          console.log(err, "=--err");
        });
      this.QrcodeDialog = true;
    },
    // 打开编辑
    editClick(row) {
      console.log(row, "=--row");
      let self = this;
      self.editUserData.sales_id = row.sales_id;
      self.editUserData.name = row.name;
      self.editUserData.mobile = row.mobile;
      self.editUserData.user_id = row.user_id;
      self.editUserData.commission = row.commission;
      self.editUserData.commission_type = row.commission_type;
      this.showEditdialog = true;
    },
    // 提交编辑业务员
    submitEditUser() {
      let self = this;
      let Params = self.editUserData;
      Params.id = self.id;
      // Params.display_Port = 1
      PromotionApi.editSales(Params, true)
        .then((data) => {
          self.$message({
            message: "编辑成功",
            type: "success",
          });
          self.getData();
        })
        .catch((err) => {
          console.log(err, "=--err");
        });

      self.showEditdialog = false;
    },
    delClick(row) {
      console.log(row);
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning",
        })
        .then(() => {
          PromotionApi.delSales({
            sales_id: row.sales_id,
            // display_Port: 1
          }).then((data) => {
            self.$message({
              message: "删除成功",
              type: "success",
            });
            self.getData();
          });
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    getValue() {
      let self = this;
      PromotionApi.setting()
        .then((data) => {
          console.log(data);
          self.addUserData.commission_type = data.data.vars.values.commission_type
          self.addUserData.commission = data.data.vars.values.commission
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.display_Port = 1
      self.loading = true;
      PromotionApi.getSales(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.product_count = data.data.product_count;
          console.log(self.tableData, 'tableData');
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.dialogBox {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/promotion/promotion/zfbstatisticaltable.vue